import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  paymentPlanId: string;
  newDueDate: Date;
  accountId: string;
};
type Data = {data: number[]; status: number};

export const updateFutureInstallmentDate = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.patch<number[], AxiosResponse<number[]>>(`/installments/future`, {
    payment_plan_id: variables.paymentPlanId,
    new_due_date: variables.newDueDate,
  });
  return {data: result.data, status: result.status};
};

export const useUpdateFutureInstallmentDate = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> =>
  useBaseMutation(updateFutureInstallmentDate, {
    ...options,
    resetQueriesKeyFn: (data, variables) => ["account", variables.accountId],
  });
